// src/pages/Complain.js
import React, { useState } from 'react';

function Complain() {
  // State for each form field
  const [orderNumber, setOrderNumber] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [issueDetails, setIssueDetails] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage('');
    setErrorMessage('');

    try {
      const response = await fetch('/api/complain', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          orderNumber,
          name,
          email,
          issueDetails,
        }),
      });

      const data = await response.json();

      if (data.success) {
        // Email sent successfully
        setSuccessMessage('Your complaint has been submitted. We’ll be in touch soon!');
        // Clear form
        setOrderNumber('');
        setName('');
        setEmail('');
        setIssueDetails('');
      } else {
        setErrorMessage(`Error: ${data.error || 'Unable to submit complaint'}`);
      }
    } catch (err) {
      console.error('Complaint error:', err);
      setErrorMessage('Something went wrong. Please try again later.');
    }

    setIsSubmitting(false);
  };

  return (
    <div className="complain-page container py-4">
      {/* Inline styles for the button */}
      <style>{`
        .black-white-btn {
          background-color: #6c757d;
          color: #fff;
          border: 1px solid #6c757d;
          transition: all 0.3s ease;
        }
        .black-white-btn:hover {
          background-color: #fff;
          color: #6c757d;
        }
      `}</style>

      <h1>Submit a Complaint</h1>
      <p>
        We’re sorry to hear about your experience. Please fill out the form below so
        we can address your concern promptly.
      </p>

      {/* Alert messages */}
      {successMessage && <div className="alert alert-success">{successMessage}</div>}
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

      {/* Complaint Form */}
      <section className="complain-form-section mt-4">
        <form className="complain-form" onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="orderNumber" className="form-label">Order / Repair ID</label>
            <input
              type="text"
              id="orderNumber"
              className="form-control"
              placeholder="e.g., 12345"
              required
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="name" className="form-label">Your Name</label>
            <input
              type="text"
              id="name"
              className="form-control"
              placeholder="Enter your full name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input
              type="email"
              id="email"
              className="form-control"
              placeholder="johndoe@example.com"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="issueDetails" className="form-label">
              Complaint Details
            </label>
            <textarea
              id="issueDetails"
              className="form-control"
              rows="5"
              placeholder="Please describe the issue or dissatisfaction you experienced"
              required
              value={issueDetails}
              onChange={(e) => setIssueDetails(e.target.value)}
            ></textarea>
          </div>

          <button
            type="submit"
            className="black-white-btn btn btn-primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit Complaint'}
          </button>
        </form>
      </section>

      {/* Additional Info or Steps */}
      <section className="complain-extra-info mt-4">
        <h2>What Happens Next?</h2>
        <ul>
          <li>Our support team will review your complaint within 1-2 business days.</li>
          <li>We’ll contact you by email or phone for any follow-up details.</li>
          <li>Our goal is to resolve your issue as quickly as possible.</li>
        </ul>
      </section>
    </div>
  );
}

export default Complain;
